import React, { useEffect } from 'react';
import Hero from '../components/marketing/Hero';
import FeatureGrid from '../components/marketing/FeatureGrid';
import HowItWorks from '../components/marketing/HowItWorks';
import FAQ from '../components/marketing/FAQ';
import CTASection from '../components/marketing/CTASection';
// added banner TODO dat to potom prec
import ConstructionBanner from '../components/marketing/ConstructionBanner';
import './Home.css';

const Home = () => {
  useEffect(() => {
    // Set page title and meta tags
    document.title = 'Video Scene Extractor - Professional Video Processing Made Simple';
    
    // Update or create meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = 'Extract scenes from videos automatically or merge multiple clips seamlessly. Fast, privacy-focused video processing tools for creators and professionals.';
    
    // Open Graph tags
    const ogTags = [
      { property: 'og:title', content: 'Video Scene Extractor - Professional Video Processing' },
      { property: 'og:description', content: 'Extract scenes from videos automatically or merge multiple clips seamlessly. Fast, privacy-focused, and easy to use.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: window.location.href }
    ];
    
    ogTags.forEach(({ property, content }) => {
      let tag = document.querySelector(`meta[property="${property}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        document.head.appendChild(tag);
      }
      tag.content = content;
    });
    
    // Twitter Card tags
    const twitterTags = [
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: 'Video Scene Extractor - Professional Video Processing' },
      { name: 'twitter:description', content: 'Extract scenes from videos automatically or merge multiple clips seamlessly.' }
    ];
    
    twitterTags.forEach(({ name, content }) => {
      let tag = document.querySelector(`meta[name="${name}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.name = name;
        document.head.appendChild(tag);
      }
      tag.content = content;
    });
  }, []);

  return (
    <div className="min-h-screen">
    <ConstructionBanner />
      <Hero />
      <FeatureGrid />
      <HowItWorks />
      <FAQ />
      <CTASection />
      
      {/* Footer */}
      <footer className="py-8 px-4 border-t border-slate-700/50">
{/*         <div className="max-w-6xl mx-auto text-center text-gray-400 text-sm"> */}
{/*           <p>© 2025 Video Scene Extractor. Built with privacy and performance in mind.</p> */}
{/*         </div> */}
      </footer>
    </div>
  );
};

export default Home;
